export const NameKeyMap: Record<string, string> = {
  '(P) Image': 'p-image',
  '(P) Title': 'p-title',
  '(P) Cart Button': 'p-cart-button',
  '(P) Description': 'p-description',
  '(P) Price': 'p-price',
  '(P) Swatches': 'p-swatches',
  '(P) Variants': 'p-variants',
  'Stamped.io - Product & Collection Page': 'stamped',
  Stamped: 'stamped',
  'Stamped.io Product Reviews': 'stamped-product-reviews',
  '(A) Image': 'a-image',
  '(A) Title': 'a-title',
  '(A) Content': 'a-content',
  'Collection Title': 'collection-title',
  'Text Block': 'text-block',
  'Text Field': 'text-field',
  'Text Area': 'text-area',
  'Email Field': 'email-field',
  'Submit Button': 'submit-button',
  Icon: 'icon',
  Row: 'row',
  Checkbox: 'checkbox',
  'Icon List Hoz': 'icon-list-hoz',
  Carousel: 'carousel',
  'Icon List': 'icon-list',
  Product: 'product',
  'Video Popup': 'video-popup',
  'Hero Banner': 'hero-banner',
  Image: 'image',
  Separator: 'separator',
  Heading: 'heading',
  Button: 'button',
};

/**
 * If module don't have "data-key"
 * @param moduleName
 * @returns
 */
export const getKeyFromModuleName = (moduleName: string) => {
  if (NameKeyMap[moduleName]) {
    return NameKeyMap[moduleName];
  } else {
    return '';
  }
};
